import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { z } from 'zod'
import { PageHeader } from '@/components/page-header'
import { ApplicationForm } from '@/features/loans/application-form'
import { requirePermission } from '@/lib/route-guards'
import { ROUTES } from '@/lib/routes'

/** Parámetros opcionales: el cliente con que se abre la solicitud (desde su ficha). */
const newLoanSearchSchema = z.object({ clientId: z.string().uuid().optional().catch(undefined) })

export const Route = createFileRoute('/_app/loans/new')({
  beforeLoad: requirePermission('loans:originate'),
  validateSearch: newLoanSearchSchema,
  component: LoansNewPage,
})

/** Nueva solicitud de crédito con simulación del plan. */
function LoansNewPage() {
  const { clientId } = Route.useSearch()
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow={
          <Link to={ROUTES.pipeline} className="inline-flex items-center gap-1 hover:text-foreground">
            <ArrowLeft className="size-3.5" aria-hidden /> Solicitudes
          </Link>
        }
        title="Nueva solicitud"
        description="Elija al cliente y el producto; la simulación muestra la cuota y el costo efectivo anual."
      />
      <ApplicationForm initialClientId={clientId} />
    </div>
  )
}
